import { trpc } from 'api'
import { useCallback } from 'react'
import { useOrderState } from './useOrderState'

const useCancelExtraResults = () => {
  const { mutate } = trpc.order.cancel.useMutation()
  const cancelExtra = useCallback(() => {
    const { result, order } = useOrderState.getState()
    if (!result) {
      return
    }
    const { items } = order

    const shouldCancel = (id: string) => {
      const item = items.find((item) => item.id === id)

      // Orphaned we need to cancel
      if (!item) {
        return true
      }
      // We also cancel extra items
      if (item?.bundleType === 'extra') {
        return true
      }
      return false
    }

    const orphaned = result.orders.filter((o) => shouldCancel(o.data.localId))

    if (orphaned.length === 0) {
      return
    }

    mutate({
      orderIds: orphaned.map((o) => o.id),
    })
  }, [mutate])

  return cancelExtra
}

export default useCancelExtraResults
